import { forwardRef } from 'react';

import type { FormControlProps } from '../FormControl/FormControl';
import { FormControl } from '../FormControl/FormControl';

import type { CheckboxProps } from './Checkbox';
import { Checkbox } from './Checkbox';

export type CheckboxFieldProps = FormControlProps & {
	name?: string;
} & CheckboxProps;

export const CheckboxField = forwardRef<HTMLInputElement, CheckboxFieldProps>(
	function CheckboxFieldRender(
		{
			label,
			labelStyle,
			helperText,
			helperStyle,
			error,
			outerStyle,
			innerStyle,
			children,
			...other
		},
		forwardedRef
	) {
		return (
			<FormControl
				label={label}
				labelStyle={labelStyle}
				helperText={helperText}
				helperStyle={helperStyle}
				error={error}
				outerStyle={outerStyle}
			>
				<label css={innerStyle}>
					<Checkbox {...other} ref={forwardedRef} />
					{children}
				</label>
			</FormControl>
		);
	}
);
